import React, { useState, ChangeEvent } from 'react';
import { observer } from 'mobx-react';
import { createStyles, makeStyles, styled } from '@material-ui/core/styles';

import adminStore, { PriceType } from '~/stores/adminStore';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Slider from '@material-ui/core/Slider';
import Input from '@material-ui/core/Input';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import Button from '@material-ui/core/Button';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Box from '@material-ui/core/Box';

import OrderModal from './OrderModal';
import authStore from '~/stores/authStore';
import Hidden from '@material-ui/core/Hidden';

export const PROMO_GRADIENT = 'linear-gradient(90deg, #25D366, #0088cc, #733ce4)';

const WhatsappToggleBtn = styled(ToggleButton)({
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        backgroundColor: '#25D366',
        paddingRight: '1rem',
        paddingLeft: '1rem'
    }
});

const TelegramToggleBtn = styled(ToggleButton)({
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        backgroundColor: '#0088cc',
        paddingRight: '1rem',
        paddingLeft: '1rem'
    }
});

const MaxToggleBtn = styled(ToggleButton)({
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        backgroundColor: '#733ce4',
        paddingRight: '1rem',
        paddingLeft: '1rem'
    }
});

const WMToggleBtn = styled(ToggleButton)({
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        background: 'linear-gradient(90deg, #25D366, #733ce4);',
        paddingRight: '1rem',
        paddingLeft: '1rem'
    }
});

const TMToggleBtn = styled(ToggleButton)({
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        background: 'linear-gradient(90deg, #0088cc, #733ce4);',
        paddingRight: '1rem',
        paddingLeft: '1rem'
    }
});

const WTMToggleBtn = styled(ToggleButton)({
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        background: PROMO_GRADIENT,
        paddingRight: '1rem',
        paddingLeft: '1rem'
    }
});

type PriceItem = { numbers: number; priceW: number; priceT: number; priceM: number; priceWT: number; priceTM: number; priceWTM: number;  };

export const WTM_PROMO_ACTIVE = true;
export const WTM_OLD_PRICE_MULTIPLIER = 2;
export const WTM_PROMO_MIN_ACCOUNTS = 100;

export const isWtmPromoUnlocked = (phoneNumbers: number): boolean =>
    WTM_PROMO_ACTIVE && phoneNumbers >= WTM_PROMO_MIN_ACCOUNTS;

// Колонка priceWTM продублирована на сервере в server/src/models/orders/wtmPricing.ts —
// правки цен акции нужно вносить в оба файла.
export const prices: Readonly<{
    en: PriceItem[];
    ru: PriceItem[];
}> = {
    en: [
        { numbers: 0, priceW: 49.99, priceT: 49.99, priceM: 49.99, priceWT: 65.99, priceTM: 65.99, priceWTM: 49.99 },
        { numbers: 1, priceW: 49.99, priceT: 49.99, priceM: 49.99, priceWT: 62.99, priceTM: 62.99, priceWTM: 49.99 },
        { numbers: 5, priceW: 39.99, priceT: 39.99, priceM: 39.99, priceWT: 52.99, priceTM: 52.99, priceWTM: 39.99 },
        { numbers: 10, priceW: 29.99, priceT: 29.99, priceM: 29.99, priceWT: 41.99, priceTM: 41.99, priceWTM: 29.99 },
        { numbers: 20, priceW: 19.99, priceT: 19.99, priceM: 19.99, priceWT: 31.99, priceTM: 31.99, priceWTM: 19.99 },
        { numbers: 50, priceW: 15.99, priceT: 15.99, priceM: 15.99, priceWT: 24.99, priceTM: 24.99, priceWTM: 15.99 },
        { numbers: 100, priceW: 13.99, priceT: 13.99, priceM: 13.99, priceWT: 21.99, priceTM: 21.99, priceWTM: 13.99 },
        { numbers: 200, priceW: 12.99, priceT: 12.99, priceM: 12.99, priceWT: 19.99, priceTM: 19.99, priceWTM: 12.99 },
        { numbers: 1000, priceW: 11.49, priceT: 11.49, priceM: 11.49, priceWT: 17.49, priceTM: 17.49, priceWTM: 11.49 }
    ],
    ru: [
        { numbers: 0, priceW: 2999, priceT: 2999, priceM: 2999, priceWT: 4499 , priceTM: 4499, priceWTM: 2999 },
        { numbers: 1, priceW: 2999, priceT: 2999, priceM: 2999, priceWT: 4199, priceTM: 4199, priceWTM: 2999 },
        { numbers: 5, priceW: 1999, priceT: 1999, priceM: 1999, priceWT: 3199, priceTM: 3199, priceWTM: 1999 },
        { numbers: 10, priceW: 1599, priceT: 1599, priceM: 1599, priceWT: 2199, priceTM: 2199, priceWTM: 1599 },
        { numbers: 20, priceW: 1299, priceT: 1299, priceM: 1299, priceWT: 1799, priceTM: 1799, priceWTM: 1299 },
        { numbers: 50, priceW: 1099, priceT: 1099, priceM: 1099, priceWT: 1599, priceTM: 1599, priceWTM: 1099 },
        { numbers: 100, priceW: 999, priceT: 999, priceM: 999, priceWT: 1499, priceTM: 1499, priceWTM: 999 },
        { numbers: 200, priceW: 949, priceT: 949, priceM: 949, priceWT: 1399, priceTM: 1399, priceWTM: 949 },
        { numbers: 1000, priceW: 899, priceT: 899, priceM: 899, priceWT: 1299, priceTM: 1299, priceWTM: 899 }
    ]
};

// Цена тира без учёта акции — по ней сравниваются строки в таблице цен.
export const matchTierPrice = (lang: 'en' | 'ru', priceKey: PriceType, phoneNumbers: number): number => {
    const pricesLang = prices[lang];
    return pricesLang.reduce((acc, { numbers, [priceKey]: price }) => {
        if (phoneNumbers >= numbers) {
            return price;
        }
        return acc;
    }, 0);
};

// Цена, которую платит пользователь: акция на WA + TG + MAX действует от WTM_PROMO_MIN_ACCOUNTS
// номеров, ниже порога тариф стоит полную цену.
export const matchPrice = (lang: 'en' | 'ru', priceKey: PriceType, phoneNumbers: number): number => {
    const price = matchTierPrice(lang, priceKey, phoneNumbers);
    if (priceKey === 'priceWTM' && WTM_PROMO_ACTIVE && !isWtmPromoUnlocked(phoneNumbers)) {
        return Number((price * WTM_OLD_PRICE_MULTIPLIER).toFixed(2));
    }
    return price;
};

const useStyles = makeStyles(({ palette, spacing, transitions }) =>
    createStyles({
        input: {
            width: '50%'
        },
        header: {
            marginBottom: '3rem'
        },
        promoChip: {
            marginLeft: 6,
            fontSize: '0.6rem',
            background: palette.secondary.main,
            color: '#fff',
            borderRadius: 4,
            padding: '1px 4px',
            fontWeight: 500,
            lineHeight: 1.2,
            verticalAlign: 'super'
        },
        // Контурный чип наследует цвет от кнопки: тёмный на невыбранном тумблере,
        // белый — на выбранном, залитом градиентом.
        promoChipMuted: {
            marginLeft: 6,
            fontSize: '0.6rem',
            border: '1px solid currentColor',
            borderRadius: 4,
            padding: '0 4px',
            fontWeight: 500,
            lineHeight: 1.3,
            verticalAlign: 'super',
            opacity: 0.65
        },
        unlockRow: {
            marginTop: spacing(2),
            maxWidth: 520
        },
        track: {
            position: 'relative',
            height: 6,
            borderRadius: 3,
            overflow: 'hidden',
            background: 'rgba(0,0,0,0.08)'
        },
        trackGhost: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: PROMO_GRADIENT,
            opacity: 0.15
        },
        trackFill: {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            overflow: 'hidden',
            transition: transitions.create('width', {
                duration: transitions.duration.standard,
                easing: transitions.easing.easeInOut
            }),
            '@media (prefers-reduced-motion: reduce)': {
                transition: 'none'
            }
        },
        // Ширина задаётся в процентах от trackFill и всегда равна ширине трека,
        // поэтому градиент открывается слева направо, а не сжимается.
        trackFillInner: {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            background: PROMO_GRADIENT
        },
        unlockFoot: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: spacing(1),
            marginTop: spacing(1),
            flexWrap: 'wrap' as const
        },
        unlockText: {
            color: palette.text.secondary,
            fontSize: '0.8rem'
        },
        unlockTextDone: {
            color: palette.secondary.main,
            fontWeight: 500,
            fontSize: '0.8rem'
        }
    })
);

const langLib = {
    en: {
        addWhatsapp: 'Add numbers',
        price: 'Price, $',
        totalCost: 'Total Cost, $',
        currency: '$',
        order: 'Order',
        promoLabel: 'PROMO',
        promoFrom: '{n}+',
        unlockHint: '{n} more {w} to unlock promo pricing',
        unlockCta: 'Take {n}',
        unlockDone: 'Promo applied · you save {sum}/mo'
    },
    ru: {
        addWhatsapp: 'Добавить номера',
        price: 'Цена, руб.',
        totalCost: 'Сумма, руб.',
        currency: 'руб.',
        order: 'Заказать',
        promoLabel: 'АКЦИЯ',
        promoFrom: 'от {n}',
        unlockHint: 'Ещё {n} {w} до акционной цены',
        unlockCta: 'Взять {n}',
        unlockDone: 'Акция применена · экономия {sum}/мес.'
    }
} as const;

const pluralRu = (n: number, one: string, few: string, many: string) => {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) {
        return one;
    }
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
        return few;
    }
    return many;
};

const Calculator = () => {
    const classes = useStyles();
    const { phoneNumbers, priceType } = adminStore;
    const { lang } = authStore;
    const lib = langLib[lang];

    const promoUnlocked = isWtmPromoUnlocked(phoneNumbers);
    const showUnlockTrack = WTM_PROMO_ACTIVE && priceType === 'priceWTM';
    const remaining = Math.max(0, WTM_PROMO_MIN_ACCOUNTS - phoneNumbers);
    const progressPct = Math.min(100, (phoneNumbers / WTM_PROMO_MIN_ACCOUNTS) * 100);
    const monthlySaving =
        phoneNumbers * matchTierPrice(lang, 'priceWTM', phoneNumbers) * (WTM_OLD_PRICE_MULTIPLIER - 1);

    const numbersWord = (n: number) =>
        lang === 'en' ? (n === 1 ? 'number' : 'numbers') : pluralRu(n, 'номер', 'номера', 'номеров');

    const promoFrom = lib['promoFrom'].replace('{n}', String(WTM_PROMO_MIN_ACCOUNTS));
    const unlockCta = lib['unlockCta'].replace('{n}', String(WTM_PROMO_MIN_ACCOUNTS));
    const unlockHint = lib['unlockHint'].replace('{n}', String(remaining)).replace('{w}', numbersWord(remaining));
    const unlockDone = lib['unlockDone'].replace('{sum}', authStore.printCost(monthlySaving));

    const handleSliderChange = (event: any, newValue: number | number[]) => {
        adminStore.setPhoneNumbers(typeof newValue === 'number' ? newValue : 0);
    };

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        adminStore.setPhoneNumbers(event.target.value === '' ? 0 : Number(event.target.value));
    };

    const handleBlur = () => {
        if (phoneNumbers < 0) {
            adminStore.setPhoneNumbers(0);
        } else if (phoneNumbers > 2000) {
            adminStore.setPhoneNumbers(2000);
        }
    };

    const [showOrderModal, setShowOrderModal] = useState(false);
    const handleOrderModal = () => {
        setShowOrderModal(!showOrderModal);
    };

    return (
        <>
            <div className={classes.header}>
                <Box alignItems="center" display="flex" style={{ gap: '1rem' }}>
                    <Typography gutterBottom>{lib['addWhatsapp']}</Typography>
                    <ToggleButtonGroup
                        size="small"
                        value={priceType}
                        exclusive
                        onChange={(_, value) => value && adminStore.setPriceType(value)}
                    >
                        <WhatsappToggleBtn value={'priceW'}>Whatsapp</WhatsappToggleBtn>
                        <MaxToggleBtn value={'priceM'}>MAX (Vk)</MaxToggleBtn>
                        <TelegramToggleBtn value={'priceT'}>Telegram</TelegramToggleBtn>
                        <WTMToggleBtn value={'priceWTM'}>
                            <Hidden xsDown>WA + TG + MAX</Hidden>
                            <Hidden smUp>WA+TG+MAX</Hidden>
                            {WTM_PROMO_ACTIVE && (
                                <span className={promoUnlocked ? classes.promoChip : classes.promoChipMuted}>
                                    {promoUnlocked ? lib['promoLabel'] : promoFrom}
                                </span>
                            )}
                        </WTMToggleBtn>
                    </ToggleButtonGroup>
                </Box>

                {showUnlockTrack && (
                    <div className={classes.unlockRow}>
                        <div className={classes.track} aria-hidden="true">
                            <div className={classes.trackGhost} />
                            {progressPct > 0 && (
                                <div className={classes.trackFill} style={{ width: `${progressPct}%` }}>
                                    <div
                                        className={classes.trackFillInner}
                                        style={{ width: `${10000 / progressPct}%` }}
                                    />
                                </div>
                            )}
                        </div>
                        <div className={classes.unlockFoot}>
                            <Typography className={promoUnlocked ? classes.unlockTextDone : classes.unlockText}>
                                {promoUnlocked ? unlockDone : unlockHint}
                            </Typography>
                            {!promoUnlocked && (
                                <Button
                                    size="small"
                                    color="secondary"
                                    onClick={() => adminStore.setPhoneNumbers(WTM_PROMO_MIN_ACCOUNTS)}
                                >
                                    {unlockCta}
                                </Button>
                            )}
                        </div>
                    </div>
                )}
            </div>

            <Grid container spacing={2} alignItems="center">
                <Grid item xs={1}>
                    <PhoneIphoneIcon />
                </Grid>
                <Grid item xs={3}>
                    <Input
                        className={classes.input}
                        value={phoneNumbers}
                        margin="dense"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        inputProps={{
                            step: 1,
                            min: 0,
                            type: 'number'
                        }}
                    />
                </Grid>
                <Grid item xs={8}>
                    <Slider
                        color="secondary"
                        value={phoneNumbers}
                        onChange={handleSliderChange}
                        max={1000}
                        valueLabelDisplay="on"
                    />
                </Grid>

                <Grid item xs={4}>
                    <FormControl fullWidth>
                        <InputLabel>{lib['price']}</InputLabel>
                        <Input
                            value={matchPrice(lang, priceType, phoneNumbers)}
                            readOnly
                            startAdornment={<InputAdornment position="start">{lib['currency']}</InputAdornment>}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={4}>
                    <FormControl fullWidth>
                        <InputLabel>{lib['totalCost']}</InputLabel>
                        <Input
                            value={(phoneNumbers * matchPrice(lang, priceType, phoneNumbers)).toLocaleString('ru')}
                            readOnly
                            startAdornment={<InputAdornment position="start">{lib['currency']}</InputAdornment>}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={4}>
                    <FormControl fullWidth>
                        <Button
                            disabled={phoneNumbers === 0}
                            onClick={handleOrderModal}
                            color="secondary"
                            variant="contained"
                            startIcon={<ShoppingCartIcon />}
                        >
                            {lib['order']}
                        </Button>
                        {showOrderModal && <OrderModal onClose={handleOrderModal} />}
                    </FormControl>
                </Grid>
            </Grid>
        </>
    );
};

export default observer(Calculator);
